<div class="ratings">
	<div class="ratings__tiles">
		<div
			class="ratings__tile"
			*ngFor="let tile of tiles; trackBy: trackByPlatform"
		>
			<typography variant="p/xs_medium" class="ratings__platform">
				{{ tile.platform }}
			</typography>
			<div class="ratings__value" *ngIf="tile.rating">
				<typography variant="h/3" class="ratings__average">
					{{ tile.rating }}
				</typography>
				<app-icon type="svg" [size]="18" [color]="starColor">
					star_filled
				</app-icon>
			</div>
			<typography
				variant="p/xs_regular"
				class="ratings__count"
				*ngIf="tile.count"
			>
				{{ tile.count }}
			</typography>
			<typography
				variant="p/xs_regular"
				class="ratings__note"
				[class.ratings__note--instead]="!tile.rating"
				*ngIf="tile.note"
			>
				{{ tile.note }}
			</typography>
		</div>
	</div>

	<div
		class="ratings__distribution"
		*ngIf="bars.length"
		[style.--star-rating-bar-fill]="accent"
	>
		<typography variant="p/xs_semibold" class="ratings__label">
			{{ distributionLabel }}
		</typography>
		<app-star-rating-bar
			*ngFor="let bar of bars; trackBy: trackByStars"
			[rating]="bar.stars"
			[count]="bar.count"
			[maxCount]="maxCount"
		></app-star-rating-bar>
	</div>
</div>
